var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.owner.isUseRowButtons
    ? _c(
        "div",
        [
          _vm._l(_vm.owner.defaultRowButtons, function (button) {
            return [
              _vm.isDesign
                ? [
                    _vm.showDefaultButtons(button.id)
                      ? _c("DsfButton", {
                          key: button.id,
                          staticStyle: { "min-width": "auto" },
                          attrs: {
                            "btn-style": "icon-text",
                            icon: button.icon,
                            title: button.title,
                          },
                        })
                      : _vm._e(),
                  ]
                : [
                    _vm.showDefaultButtons(button.id)
                      ? _c("DsfButton", {
                          key: button.id,
                          class: [button.id + "-button-" + _vm.scope.row.$hash],
                          staticStyle: { "min-width": "auto" },
                          attrs: {
                            "btn-style": "icon-text",
                            icon: button.icon,
                            title: button.title,
                          },
                          on: {
                            click: function ($event) {
                              return button.handler(_vm.scope)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
            ]
          }),
        ],
        2
      )
    : _c(
        "div",
        [
          _vm.isDesign
            ? [
                _c("DsfButtonBar", {
                  staticClass: "ds-no-padding operate-column",
                  attrs: {
                    size: "small",
                    "max-number": _vm.owner.rowButtonsMaxNumber,
                    "more-button-text": _vm.owner.rowButtonsMoreText,
                    "more-button-style": _vm.owner.rowButtonsMoreStyle,
                    buttons: _vm.owner.rowButtons,
                    "emit-prefix": "row-button",
                    local: _vm.scope.row,
                    align: "center",
                  },
                }),
              ]
            : [
                _c("DsfButtonBar", {
                  staticClass: "ds-no-padding operate-column",
                  attrs: {
                    size: "small",
                    "render-button": _vm.renderRowButton,
                    "max-number": _vm.owner.rowButtonsMaxNumber,
                    "more-button-text": _vm.owner.rowButtonsMoreText,
                    "more-button-style": _vm.owner.rowButtonsMoreStyle,
                    buttons: _vm.scope.row.$buttons,
                    "emit-prefix": "row-button",
                    local: _vm.scope.row,
                    "slot-scope-data": _vm.scope,
                    align: "center",
                  },
                }),
              ],
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }